/**
 * Only ever link to — or frame — an https address that came from data (the public settings): defence in depth
 * on top of the server's validation, so a `javascript:` or `data:` value can never reach an `href` or a `src`.
 */
export function httpsOnly(value: string | undefined | null): string | null {
  if (!value) return null;
  try {
    return new URL(value).protocol === 'https:' ? value : null;
  } catch {
    return null;
  }
}
